import check from '../libraries/check-types-ext';
import AppError from '../libraries/AppError';
import { PriceMgr } from '../orders/PriceMgr';
import ProductGroup from './ProductGroup';
import { isRuleWithTimePatternActive } from '../priceRules/priceRulesHelpers';
import { effectiveDiscountForPickupDate } from '../libraries/PickupDateRule';
export default class Product {
    constructor(productNode, productMapper) {
        check.object.orFail(productNode, 'productNode');
        check.object.orFail(productMapper, 'productMapper');
        if (!('id_ref' in productNode)) {
            check.string.orFail(productNode.id, 'productNode.id', productNode);
        }
        if ('id_ref' in productNode && productNode.id_ref) {
            productMapper.resolveProduct(productNode.id_ref, (resolvedProduct) => {
                this.init(resolvedProduct);
                if (Array.isArray(resolvedProduct.groups) && resolvedProduct.groups.length > 0) {
                    this.groups = resolvedProduct.groups.map((groupNode) => new ProductGroup(groupNode, productMapper, this));
                }
            });
        }
        else {
            this.init(productNode);
            if ('groups' in productNode && productNode.groups) {
                this.groups = productNode.groups.map((groupNode) => new ProductGroup(groupNode, productMapper, this));
            }
            productMapper.registerProduct(this);
        }
    }
    isComposite() {
        return (this.groups && this.groups.length > 0) || (this.configurations && this.configurations.length > 0);
    }
    getGroup(groupId) {
        const group = this.groupMap[groupId];
        if (!group) {
            throw AppError.ConfigurationGroupNotFoundError()
                .addData('productId', this.id)
                .addData('groupId', groupId)
                .addData('existing groupIds', Object.values(this.groups).map((g) => g.id));
        }
        return group;
    }
    getConfig(configurationId) {
        check.string.orFail(configurationId);
        const result = this.configurations.find((configEl) => configEl.id === configurationId);
        check.object.orFail(result);
        return result;
    }
    init(productNode) {
        check.object.orFail(productNode);
        check.string.orFail(productNode.id, () => JSON.stringify(productNode));
        for (const key in productNode) {
            if (Object.prototype.hasOwnProperty.call(productNode, key)) {
                this[key] = productNode[key];
            }
        }
        this.groupMap = {};
        if (this.groups) {
            this.groups.forEach((g) => {
                this.groupMap[g.id] = g;
            });
        }
        if (this.id_ref) {
            delete this.id_ref;
        }
    }
    getName() {
        return this.name;
    }
    getDisplayDiscount(pickupDate) {
        if (!pickupDate) {
            return this.discount;
        }
        return effectiveDiscountForPickupDate(this.applicableDiscounts, this.discount, pickupDate);
    }
    getPrice(pickupDate) {
        const discount = this.getDisplayDiscount(pickupDate);
        if (discount && discount.voucherPattern && discount.voucherPattern.length > 0) {
            return this.price;
        }
        return PriceMgr.compute({
            price: this.price,
            quantity: 1,
            discount: discount,
        }).price;
    }
    getPriceInGroup({ applyDiscount, pickupDate } = { applyDiscount: true }) {
        if (applyDiscount === undefined) {
            applyDiscount = true;
        }
        const discount = this.getDisplayDiscount(pickupDate);
        if (discount && discount.discountTimePattern) {
            const isValidDiscount = isRuleWithTimePatternActive(discount.discountTimePattern, this.timeZone);
            if (!isValidDiscount) {
                applyDiscount = false;
            }
        }
        if (typeof this.priceStructure === 'object') {
            const priceInGroup = typeof this.priceStructure.priceInGroup !== 'undefined'
                ? this.priceStructure.priceInGroup
                : this.priceStructure.defaultPrice;
            if (!applyDiscount || (discount && discount.voucherPattern && discount.voucherPattern.length > 0)) {
                return priceInGroup;
            }
            return PriceMgr.compute({
                price: priceInGroup,
                quantity: 1,
                discount: discount,
            }).price;
        }
        return this.getPrice(pickupDate);
    }
}
